<template>
    <div class="rt-input__wrapper" :class="{ floating: floatingLabel, filled: inputValue, 'no-border': withoutBorder, 'error': borderError }">
        <div class="rt-input" :class="{'rt-input--error': error }">
            <input ref="input" class="rt-input__field"
                   :autocomplete="autocomplete"
                   :type="inputType"
                   :name="name"
                   :disabled="disabled"
                   :placeholder="placeholder"
                   :value="inputVal"
                   :maxlength="maxLength ? maxLength : 9999"
                   :readonly="readOnly"
                   :autofocus="autofocus"
                   @input="handleUpdateInput"
                   @blur="$emit('blur', $event.target.value)"
                   @keyup.enter="$emit('enterPressed', $event.target.value)">
            <span class="focus-border"></span>
        </div>
        <div v-if="!error && hintExists" class="rt-input__hint">{{ hint }}</div>
        <div v-if="!error && floatLabelVisible" class="rt-input__floating">{{ floatingLabel }}</div>
        <div v-if="error" class="rt-input__error">{{ errorMessage }}</div>
        <button class="btn-show-password btn-normal" :class="{inactive: inputType === 'text'}" @click="showVisiblePassword" v-if="type === 'password' && inputValue">
            <img class="rt-input__icon" src="/assets/app/quiz/icon-eye.svg">
        </button>
    </div>
</template>

<script>
    import _ from 'lodash';
    export default {
        data: function() {
          return {
            inputValue: '',
            inputType: 'text'
          }
        },
        methods: {
          focus() {
            this.$nextTick(this.$refs.input.focus());
          },
          updateValue(value) {
            this.$refs.input.value = value;
            this.inputValue = value;
          },
          handleUpdateInput(event) {
            this.$emit('input', event.target.value);
            this.inputValue = event.target.value;
          },
          showVisiblePassword() {
            if (this.inputType === 'password') {
              this.inputType = 'text';
            } else {
              this.inputType = 'password';
            }
          }
        },
        computed: {
          inputVal() {
            return this.value ? this.value : this.inputValue;
          },
          floatLabelVisible() {
            return this.floatingLabel && this.inputValue;
          },
          hintExists() {
            return !_.isEmpty(this.hint)
          }
        },
		watch: {
		  value(newVal, oldVal) {
			if (newVal !== oldVal) {
			  this.inputValue = newVal;
			}
		  },
		  inputValue(newVal) {
			if (newVal) {
			  this.$refs.input.value = newVal;
			}
		  },
		  value(newVal) {
			if (newVal !== undefined) {
			  this.inputValue = newVal;
			}
		  }
		},
        created() {
          if (this.type) {
            this.inputType = this.type;
          }
          this.inputValue = this.value;
		  if (this.editType) {
            this.inputType = this.editType;
          }
        },
        props: ['type', 'editType', 'name',  'disabled', 'placeholder', 'value', 'error', 'borderError', 'errorMessage', 'autocomplete', 'autofocus', 'hint', 'floatingLabel', 'maxLength', 'withoutBorder', 'readOnly'],
    }
</script>

<style scoped lang="scss">

    @import './variables';
    .rt-input__wrapper {
      position: relative;
      overflow: hidden;
    }
    .rt-input__wrapper {
	  &.floating, &.no-border {
		border-radius: 5px;
		&:focus-within {
		  box-shadow: 0 0 5px $primary-blue;
		}
	  }
	  &.no-border {
		border-radius: $default_border_radius;
      }
	  &.error {
		border: 1px solid $red;
	  }
      &.floating {
        background: #EEF5FF;
        position: relative;
        border-radius: 5px;
        &.filled {
          .rt-input__field {
            padding-top: 19px;
            padding-bottom: 9px;
            transform: translateY(4px);
          }
        }
        .rt-input__field {
          padding: 14px 16px;
          margin-top: 0;
          font-weight: 700;
          color: $title-dark-grey;
          border-color: transparent;
		  &:focus,&:hover {
			border-color: transparent !important;
		  }
        }
      }
	  &.no-border {
		.rt-input__field {
		  background: rgba(238, 245, 255, 0.7);
		  padding: 14px 18px;
		  margin: 0;
		  border: 1px solid transparent;
		  border-radius: 5px;
		  font-family: $text-font;
		  &:focus,&:hover {
		    border-color: transparent !important;
		  }
		}
	  }
      .rt-input__floating {
        position: absolute;
        top: 8px;
        left: 16px;
        margin: 0;
        pointer-events: none;
        font-size: 12px;
        color: $title-grey;
      }
    }
    .rt-input:first-child {
        margin-top: 0;
        padding-top: 0;
    }

    .rt-input:last-child {
        margin-bottom: 0;
    }

    .rt-input {
        position: relative;
        font-size: 1rem;

        &__hint {
            color: $dark-grey;
            font-size: 11px;
            text-align: left;
            margin-top: 0.3rem;
            margin-left: 0.2rem;
        }
    }

    .rt-input__field[disabled] {
        border-bottom: 1px solid transparent;
        opacity: 0.5;
    }

    input.rt-input__field, input.rt-input__field:invalid {
        color: $dark-blue;
        border-radius: 0;
    }

    .rt-input__field::placeholder,
    .rt-input__field:focus::placeholder {
        color: $title-grey;
        font-weight: 400;
        font-style: normal;
    }

    .focus-border {
        display: none;
    }

    .rt-input__field:focus ~ .focus-border {
        width: 100%;
        transition: 0.3s;
    }

    .rt-input__field ~ .focus-border {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 1px;
        background-color: $primary-blue;
        transition: 0.3s;
    }

    .rt-input__field {
        background-color: transparent;
        font-size: 1em;
        border: 0;
        padding: 3.8px 2px 10.3px;
        margin: 1.25em 0 0;
        font-weight: 400;
        width: 100%;
        border-bottom: 1px solid $dark-grey;
        line-height: 1.2em;
        font-style: normal;
		&:hover {
		  border-bottom: 1px solid transparent !important;
        }
    }
    .rt-input.rt-input--error {
        .rt-input__field {
            border-bottom: 1px solid $red;
            color: $red;
        }

        .rt-input__field::placeholder {
            color: $red;
        }

        .rt-input__field:focus {
            color: $dark-blue;
        }
        .rt-input__field:focus::placeholder {
            color: $grey;
        }
    }

    .rt-input__error {
        margin-left: .2rem;
        text-align: left;
        font-size: 0.8rem;
        color: $red;
    }
    .btn-show-password {
      position: absolute;
      top: 19px;
      right: 16px;
      cursor: pointer;
      &.inactive {
        opacity: 0.6;;
      }
    }

</style>
